var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBudgetsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#050505;stroke-width:0.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.4,3.2c0,1.4-2,2.5-4.5,2.5c-2.5,0-4.5-1.1-4.5-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.4,5.2c0,1.4-2,2.5-4.5,2.5c-2.5,0-4.5-1.1-4.5-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.4,7.3c0,1.4-2,2.5-4.5,2.5c-0.6,0-1.3-0.1-1.8-0.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.4,9.4c0,1.4-2,2.5-4.5,2.5c-0.6,0-1.3-0.1-1.8-0.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.4,11.4c0,1.4-2,2.5-4.5,2.5c-0.6,0-1.3-0.1-1.8-0.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.2,8.1c-2.5,0-4.5,1.1-4.5,2.5v6.2c0,1.4,2,2.5,4.5,2.5c2.5,0,4.5-1.1,4.5-2.5v-6.2 C10.7,9.2,8.7,8.1,6.2,8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.7,10.6c0,1.4-2,2.5-4.5,2.5c-2.5,0-4.5-1.1-4.5-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.7,12.7c0,1.4-2,2.5-4.5,2.5c-2.5,0-4.5-1.1-4.5-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.7,14.8c0,1.4-2,2.5-4.5,2.5c-2.5,0-4.5-1.1-4.5-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,15.8c0.6,0.1,1.2,0.2,1.8,0.2c2.5,0,4.5-1.1,4.5-2.5V3.2c0-1.4-2-2.5-4.5-2.5c-2.5,0-4.5,1.1-4.5,2.5v4.1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudgetsIcon);
export default __webpack_public_path__ + "static/media/budgets-icon.1116161c231e253e5abe134590ee61f5.svg";
export { ForwardRef as ReactComponent };